/**
 * Stima di consegna dinamica: "Ordina oggi, consegna stimata entro <data>".
 * Si conta un numero di giorni lavorativi (predefinito 3) da oggi, escludendo sabato, domenica e le festivita
 * nazionali italiane. Nel periodo natalizio mostra anche la riga dedicata. Testi dagli attributi data-*.
 */
class DeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const days = Math.max(1, Number(this.dataset.days) || 3);
    const today = new Date();
    const date = DeliveryEstimate.addBusinessDays(today, days);
    const formatted = new Intl.DateTimeFormat(document.documentElement.lang || 'it-IT', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    }).format(date);

    const lines = [];
    const template = this.dataset.text || '';
    if (template) lines.push((this.dataset.text || '').replace('{date}', formatted));

    const christmas = this.dataset.christmasText || '';
    if (christmas && this.#inChristmasWindow(today)) lines.push(christmas);

    this.replaceChildren(
      ...lines.map((text) => {
        const p = document.createElement('p');
        p.className = 'delivery-estimate__line';
        p.textContent = text;
        return p;
      })
    );
    this.hidden = lines.length === 0;
  }

  /** @param {Date} today */
  #inChristmasWindow(today) {
    const parse = (/** @type {string | undefined} */ value, /** @type {string} */ fallback) => {
      const [m, d] = (value || fallback).split('-').map(Number);
      return m * 100 + d;
    };
    const from = parse(this.dataset.christmasFrom, '11-15');
    const to = parse(this.dataset.christmasTo, '12-14');
    const now = (today.getMonth() + 1) * 100 + today.getDate();
    return now >= from && now <= to;
  }

  /**
   * @param {Date} start
   * @param {number} count
   */
  static addBusinessDays(start, count) {
    const date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    let added = 0;
    while (added < count) {
      date.setDate(date.getDate() + 1);
      if (DeliveryEstimate.isBusinessDay(date)) added += 1;
    }
    return date;
  }

  /** @param {Date} date */
  static isBusinessDay(date) {
    const weekday = date.getDay();
    if (weekday === 0 || weekday === 6) return false;
    return !DeliveryEstimate.holidays(date.getFullYear()).has(`${date.getMonth() + 1}-${date.getDate()}`);
  }

  /** Festivita nazionali italiane: fisse e Lunedi dell'Angelo (Pasquetta). @param {number} year */
  static holidays(year) {
    const set = new Set(['1-1', '1-6', '4-25', '5-1', '6-2', '8-15', '11-1', '12-8', '12-25', '12-26']);
    // Pasqua (algoritmo di Gauss/Meeus per il calendario gregoriano)
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    const easterMonday = new Date(year, month - 1, day + 1);
    set.add(`${easterMonday.getMonth() + 1}-${easterMonday.getDate()}`);
    return set;
  }
}

if (!customElements.get('delivery-estimate')) customElements.define('delivery-estimate', DeliveryEstimate);
